
import axios from 'axios'
import UiSession from '../Tracking/LogManager'

export default class FmdBaseDal {
    session: UiSession;

    constructor(session: UiSession) {
        this.session = session;
    }
    //axios.defaults.headers.common = { 'Authorization': "bearer " + "eyJhbGciOiJSUzI1NiIsImtpZCI6IjUyMzdhMjUxNjBmN2FhYjJlYTYwN2JkZDJkZjE2YWQxIiwidHlwIjoiSldUIn0.eyJuYmYiOjE1Mzk4MDkxMTMsImV4cCI6MTU3MTM0NTExMywiaXNzIjoiaHR0cDovL2xvY2FsaG9zdDo1MDAwIiwiYXVkIjpbImh0dHA6Ly9sb2NhbGhvc3Q6NTAwMC9yZXNvdXJjZXMiLCJhcGkxIl0sImNsaWVudF9pZCI6ImltcGxpY2l0Iiwic3ViIjoiYjRkZTRmZDgtZjkxZS1lODExLTgwYzMtMDAwZDNhMjE0Y2U0IiwiYXV0aF90aW1lIjoxNTM5ODA5MTEzLCJpZHAiOiJsb2NhbCIsInNjb3BlIjpbIm9wZW5pZCIsInByb2ZpbGUiLCJlbWFpbCIsImFwaTEiXSwiYW1yIjpbInB3ZCJdfQ.PE9 Lbq7epTjUNODHTHThqMLa3mZFVXJVOWTAISVPIRlCKvIKEFH5GoEAFAx-jh9wT5VxYznnM-eNI58mcAfSLepNSJNGE4GWaNayGYdcyzzLp44hf-J5RIoqecznTQGYzH1IBeUv37qs1JvDJr7kdVW0MUmP0yytZo4_QWUrLdsIc9ZInb0RiXTR4EgMBe2Bq9AekzhWU2__7IlIoSWQOdsUjt77Efj_jBUCAYHrzHQsxJoxQg7dzA1TO7CZsnwNa9LMvHasOnuJE5ATspFNxTmamUhvLICqoEuZZu5U_r8LRoxBk5TtpmtA1k3MMSQjIE-2Yd7-Pw_xEYPJKTsw" }

    public static BaseUri: string = "http://localhost:5005"
    //protected BaseUri: string = "https://sit-api.vcaresystems.co.uk/"
    public static Token: string;

    protected GetAxiosConfig(): any {
        var config = {
            headers: { 'Authorization': "bearer " + FmdBaseDal.Token },
            'Content-Type': 'application/json'
        };

        return config;

    }

    protected HandleError(error: any) {
        if (error.response.status == 401) {
            // Start the Authoization flow
            return false;
        }

        return false;
    }

    protected async Delete<T>(url: string) {
        var qurl = FmdBaseDal.BaseUri + url;
        var config = this.GetAxiosConfig();
        var response = await axios.delete(qurl, config);
        var items = response.data as T;
        return items;
    }

    protected async Get<T>(url: string) {
        var start_time = new Date().getTime();
        var qurl = FmdBaseDal.BaseUri + url;
        var config = this.GetAxiosConfig();
        var response = await axios.get(qurl, config);

        this.AddStat(start_time, qurl);

        var items = response.data as T;
        return items;
    }


    protected async Put<T>(url: string, data: T) {
        var qurl = FmdBaseDal.BaseUri + url;
        console.log("Axios PUT " + qurl, data);
        var config = this.GetAxiosConfig();

        return axios.put(qurl, data, config)
            .then(reponse => {
                return true;
            }).catch(error => {
                return this.HandleError(error)
            });
    }

    protected async Post<T>(url: string, data: T) {
        var qurl = FmdBaseDal.BaseUri + url;
        var config = this.GetAxiosConfig();
        return axios.post(qurl, data, config)
            .then(response => {
                return response.data as T;
            })
    }
    protected async Post2<T, K>(url: string, data: T) {
        var qurl = FmdBaseDal.BaseUri + url;
        var config = this.GetAxiosConfig();
        return axios.post(qurl, data, config)
            .then(response => {
                return response.data as K;
            })
    }

    private async AddStat(startTime: number, url: string): Promise<void> {
        var l = document.createElement("a");
        l.href = url;

        var path = l.pathname;
        var request_time = new Date().getTime() - startTime;
        if (this.session) {
            this.session.LogStat("Ajax", "Get", path, request_time);
        }
    }
}



// WEBPACK FOOTER //
// ./ClientApp/scripts/FmdBaseDal.ts